// extracted by mini-css-extract-plugin
export default {"cls1":"VeloStrengthMeter-Error_cls1__UkZRZ","cls2":"VeloStrengthMeter-Error_cls2__m-S5X VeloStrengthMeter-Error_cls1__UkZRZ"};